console.log("Like what you see? Connect with us at https://unlimited.studio 🚀");


// Bundle integration: expose global helpers for the app
(() => {
  const CART_DRAWER_OPEN = 'fluco:modal:cartDrawer:open';
  const CART_CHANGED = 'cart:changed';

  // Opens the theme's cart drawer
  window.opusOpen = function opusOpen() {
    try {
      window.dispatchEvent(new Event(CART_DRAWER_OPEN));
    } catch (e) {
      // no-op
    }
  };

  // Refreshes cart UI by fetching /cart.js and emitting the theme's CART_CHANGED event
  window.opusRefreshCart = function opusRefreshCart() {
    const base = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base) || '/cart';
    const url = base + '.js';
    fetch(url, { credentials: 'include' })
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent(CART_CHANGED, { detail: { cartData: cart } }));
      })
      .catch(() => {});
  };
})();

// Designed & developed by unlimited.studio – https://unlimited.studio